import { useContext, useEffect, useState } from "react";
import { DamageGlassSelector } from "../components/DamageGlassSelector";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { t } from "../i18n";

export const DamageGlass = () => {
	const { data, isTransitioning, FLOW } = useContext(AppContext);
	const [nextPage, setNextPage] = useState("damageType");
	const previousPage = FLOW === "mapfre" ? "intro" : "selectCenter";

	useEffect(() => {
		setNextPage(
			data.damageGlass && !data.damageGlass.includes("Parabrisas")
				? "selectDateTime"
				: "damageType"
		);
	}, [data.damageGlass]);

	return (
		<>
			<Header />
			<Content data={data} isTransitioning={isTransitioning} />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = ({ data, isTransitioning }) => {
	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_damage_glass">
				<div className="content_title">
					<h2 className="select_damage_glass">
						<strong>{t("Selecciona el cristal dañado")}</strong>
					</h2>
				</div>
				<DamageGlassSelector />
				<span
					className={
						"selected_damage_glass kensei_03" +
						(data.damageGlass ? "" : " hidden")
					}
				>
					{data.damageGlass}
				</span>
			</div>
		</div>
	);
};
